import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { FieldSearchModel } from '@sb-tools/typescript/models/field-search.model';
import { FormType } from '@sb-tools/typescript/enums/form-type.enum';
import { TranslateModule } from '@ngx-translate/core';
import { FormFieldComponent } from '../../../../sb-modules/Frontend-form-field-module/form-field/form-field.component';

@Component({
    selector: 'app-field-search-item',
    templateUrl: './field-search-item.component.html',
    styleUrls: ['./field-search-item.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [FormsModule, TranslateModule, NgSelectComponent, NgOptionTemplateDirective, FormFieldComponent],
})
export class FieldSearchItemComponent implements OnInit {
    @ViewChild('fieldSelect') fieldNgSelect: NgSelectComponent;

    @Input() allFields: FieldSearchModel[] = [];
    @Input() index;
    @Input() searchItem = {
        key: null,
        value: '',
    };

    fieldKey: any = null;
    formTypesEnum = FormType;

    ngOnInit() {
        this.fieldKey = this.searchItem.key ? this.getFieldKey(this.searchItem.key) : null;
        if (this.fieldKey) {
            this.fieldKey.value = this.searchItem.value;
        }
    }

    getFieldKey(id: number): FieldSearchModel {
        return this.allFields.find((field) => {
            return field.id === id;
        });
    }

    onSelect() {
        // Clearing fieldKey.value in child form element by update (if fieldKey.type is equal)
        const temp = this.fieldKey;
        this.fieldKey = {};
        setTimeout(() => {
            this.fieldKey = temp;
        }, 1);
    }
}
